import { computed, getCurrentInstance, Ref } from "@vue/composition-api";
import { differenceInMinutes } from "date-fns";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";

export const getTagsBySlugs = (slugs: string[], type: TagInfoType, tags: TagInfo[]) => {
  return slugs.map(slug => tags.find(i => i.slug === slug && i.type === type)).filter(i => !!i) as TagInfo[];
};

export default function useTags(types: TagInfoType[], tagsSlugs?: Ref<string[]>, hashtagsSlugs?: Ref<string[]>) {
  const vm = getCurrentInstance();

  const tags = computed(() => {
    if (!vm) return [];
    return types.reduce((acc: TagInfo[], type) => acc.concat(vm.$store.state.tags[type]?.items ?? []), []);
  });

  const tagsBySlug = computed(() => getTagsBySlugs(tagsSlugs?.value ?? [], TagInfoType.USERS, tags.value));
  const hashtagsBySlug = computed(() => getTagsBySlugs(hashtagsSlugs?.value ?? [], TagInfoType.POSTS, tags.value));

  const getTags = async () => {
    if (types.length === 0) return;
    const typesToUpdate = types.filter(type => {
      const timeStamp = vm?.$store.state.tags[type]?.timestamp ?? "";
      if (!timeStamp) return true;
      return differenceInMinutes(new Date(), new Date(timeStamp)) >= 5;
    });

    if (typesToUpdate.length === 0) return;
    const response = await providers.TagsProvider.findAll({
      data: { type: typesToUpdate.length === 1 ? typesToUpdate[0] : undefined },
    });

    typesToUpdate.forEach(type => {
      vm?.$store.commit(MUTATION_TYPES.SET_TAGS, {
        type,
        items: typesToUpdate.length === 1 ? response : response.filter(p => p.type === type),
      });
    });
  };

  return {
    tagsBySlug,
    hashtagsBySlug,
    tags,
    getTags,
  };
}
